module.exports = __webpack_public_path__ + "img/home-popup-title1.aced9cda.png";